module.exports = __webpack_public_path__ + "static/media/unit 1-9.6e544171.jpg";